"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assignment = void 0;
/**
 * It contains information about the assignment
 * this model is used to assign an assessment template to a class
 *
 * @property {string}      title          - assessment title
 * @property {string}      contextId      - represents the assessment context where it was assigned, i.e classId
 * @property {string}      contextType    - external value indicating the context type, i.e class, group, student, etc
 * @property {string}      schoolId       - School unique identifier
 * @property {Date}        endDate        - assessment end date
 * @property {Date}        startDate      - assessment start date
 * @property {string[]}    assigneeIds    - assignee list
 * @property {boolean}     autoLaunch     - indicates when the assignment would be auto launched
 *
 */
var Assignment = /** @class */ (function () {
    function Assignment(data) {
        if (data === void 0) { data = {}; }
        this.contextType = 'class';
        this.autoLaunch = false;
        Object.assign(this, data);
    }
    return Assignment;
}());
exports.Assignment = Assignment;
